import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 512 512' className={className}>
      <path
        d='M289.584121,512 L289.584121,278.469863 L367.939042,278.469863 L379.69459,187.432019 L289.584121,187.432019 L289.584121,129.317631 C289.584121,102.968306 296.871109,85.0115574 334.69876,85.0115574 L382.866146,84.9917558 L382.866146,3.56428751 C374.536274,2.48180019 345.942767,0 312.662883,0 C243.169177,0 195.59254,42.4183216 195.59254,120.301304 L195.59254,187.432019 L117,187.432019 L117,278.469863 L195.59254,278.469863 L195.59254,512 L289.584121,512 Z'
        fill={fillColor}
      />
    </svg>
  );
});

export default React.memo(Icon);
